import { makeAutoObservable } from 'mobx';
import {api} from 'shared/core';
import {endpoints} from 'main/tools';

class BenefitsNotEnabledState {
  interestedInBenefitsModalOpen = false;

  constructor() {
    makeAutoObservable(this);
  }

  openInterestedInBenefitsModal() {
    this.interestedInBenefitsModalOpen = true;
  }

  closeInterestedInBenefitsModal() {
    this.interestedInBenefitsModalOpen = false;
  }

  async submit(benefitServiceType) {
    await api.post(endpoints.BENEFITS.INTERESTED, {benefitServiceType, source: 'benefits_page'});
    this.openInterestedInBenefitsModal();
  }
}

export default BenefitsNotEnabledState;
